module.exports = __webpack_public_path__ + "img/icon-cont-3.de0706b6.png";